function RoofingOrder({ yurtTrait, walls}) {
  return ( 
    <p>HELLO</p>
  )

}

export default RoofingOrder